import { compose } from 'ramda';
import { withDetailsContext } from '../withContext';
import { withFetch } from '../withLeaderBoardDetails';
import withDetailsUpdates from './withDetailsUpdates';
import withReducer from './withReducer';

export default compose(
    withReducer,
    withDetailsContext,
    withFetch,
    withDetailsUpdates
);
